import { Helmet } from "react-helmet-async";

function AboutUsHelmetComponent() {
  const title =
    "Tietoa Spiderlegs Productionsista | Tapahtumatekniikan vuokraus";

  const description =
    "Spiderlegs Productions on Keravalla toimiva tapahtumatekniikan ja äänentoiston vuokrauspalvelu. Tarjoamme luotettavaa laitevuokrausta, kuljetuksen ja asennuksen Etelä-Suomen alueella.";

  const url = "https://spiderlegsproductions.com/meista/";

  const image = "https://spiderlegsproductions.com/assets/new_logo.webp";

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Meta description */}
      <meta name="description" content={description} />

      {/* Meta keywords: ei kriittinen Googlelle, mutta pidetään sivun aiheessa */}
      <meta
        name="keywords"
        content="Spiderlegs Productions, tapahtumatekniikka, äänentoiston vuokraus, laitevuokraus, esitystekniikka, valotekniikka, Kerava, Etelä-Suomi"
      />

      {/* Author */}
      <meta name="author" content="Spiderlegs Productions" />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spiderlegs Productions" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="fi_FI" />

      {/* JSON-LD: LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://spiderlegsproductions.com/#localbusiness",
          name: "Spiderlegs Productions",
          url: "https://spiderlegsproductions.com/",
          logo: image,
          image,
          email: "info@spiderlegsproductions.com",
          telephone: "+358443519265",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Kerava",
            addressCountry: "FI",
          },
          areaServed: {
            "@type": "AdministrativeArea",
            name: "Etelä-Suomi",
          },
          sameAs: [
            "https://www.facebook.com/spiderlegsproductions/",
            "https://www.instagram.com/spiderlegsproductions/",
            "https://www.linkedin.com/in/spiderlegs-productions/",
            "https://www.tiktok.com/@spiderlegsproductions",
          ],
        })}
      </script>

      {/* JSON-LD: Service */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "@id": "https://spiderlegsproductions.com/#service-event-technology",
          serviceType: "Tapahtumatekniikan ja äänentoiston vuokraus",
          provider: {
            "@type": "LocalBusiness",
            "@id": "https://spiderlegsproductions.com/#localbusiness",
          },
          areaServed: {
            "@type": "AdministrativeArea",
            name: "Etelä-Suomi",
          },
          availableChannel: {
            "@type": "ServiceChannel",
            serviceLocation: {
              "@type": "Place",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Kerava",
                addressCountry: "FI",
              },
            },
          },
        })}
      </script>

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default AboutUsHelmetComponent;